module.exports = __webpack_public_path__ + "static/Thefork-a79ae48021befbf3222615b31bb5b685.svg";